export const mobileStickySubmitSx = {
    container: {
        position: "fixed",
        left: 0,
        width: "100%",
        padding: "8px 16px",
        boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
        zIndex: 1002,
        display: { xs: "flex", md: "none" },
        justifyContent: "center",
        background: "#fff"
    },

    buttonWrapper: {
        display: "flex",
        gap: 2
    },

    cancelButton: {
        textAlign: "center",
        backgroundColor: "red",
        display: "flex",
        alignItems: "center",
        "&:hover": {
            backgroundColor: "red"
        }
    },

    saveButton: {
        textAlign: "center",
        backgroundColor: "green",
        "&:hover": {
            backgroundColor: "green"
        }
    },

    circularProgress: {
        color: "white"
    }
};
